import React from 'react'
import PropTypes from 'prop-types'
import { Button, Tooltip } from '../../../../imports'

const ButtonSetting = props => (
    <Tooltip content={props.title}>
        <Button block onClick={() => props.onClick()}>
            {props.label}
        </Button>
    </Tooltip>
)

ButtonSetting.propTypes = {
    label: PropTypes.string,
    title: PropTypes.string,
    onClick: PropTypes.func,
}

export default ButtonSetting



// WEBPACK FOOTER //
// ./src/features/Settings/components/Settings/components/ButtonSetting/index.js